module.exports = __webpack_public_path__ + "static/Clarity of data 3-35153aa1db3e60a2e76466eb0756a0f4.png";